import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-useless-computed-key */import React, { Component } from 'react';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import styled from 'styled-components';
import { openModal } from '../redux/modal';
import { performApiRequest, invalidateApiDataRequest, getResultData, getApiDataRequest } from '../redux/apiData';
import { textStyles, colorPalette, fonts } from '../styles/styleGuide';
import { toBreakpoint } from '../styles/breakpoints';
import FormGenerator from './shared/forms/FormGenerator';
import get from 'lodash.get';
import { getRedirectUrl } from '@/processes/getRedirectUrl';
import withMutationRequest, { WithMutationRequestProps } from '@/hocs/withMutationRequest';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    env = _ownProps$match$param.env;
  return {
    facebookLoginUrl: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(projectSlug),
      env: String(env)
    }), 'facebookLoginUrl', undefined),
    signUpRequest: getApiDataRequest(state.apiData, 'signupUser', {
      projectSlug: String(projectSlug)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    onSignup: function onSignup(loginValues) {
      dispatch(performApiRequest('signupUser', {
        projectSlug: String(projectSlug)
      }, _objectSpread({}, loginValues)));
    },
    redirectToLoggedIn: function redirectToLoggedIn(redirectUrl) {
      dispatch(invalidateApiDataRequest('getSettings', {
        projectSlug: String(projectSlug),
        env: 'closed'
      }));
      dispatch(invalidateApiDataRequest('getPage', {
        pagePath: String(projectSlug) + '/closed'
      }));
      window.location.href = redirectUrl;
    },
    handleClick: function handleClick(evt, object) {
      evt.preventDefault();
      dispatch(openModal(colorPalette.beige, object));
    }
  };
};
var LoginForm = /*#__PURE__*/function (_Component) {
  function LoginForm() {
    var _this;
    _classCallCheck(this, LoginForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LoginForm, [].concat(args));
    _defineProperty(_this, "state", {
      register: false,
      type: 'password',
      error: '',
      loading: false
    });
    _defineProperty(_this, "handleSubmit", function (_ref) {
      var email = _ref.email,
        name = _ref.name,
        password = _ref.password,
        _remember_me = _ref._remember_me;
      var _this$props = _this.props,
        onSignup = _this$props.onSignup,
        mutation = _this$props.mutation;
      var register = _this.state.register;
      var redirectUrl = getRedirectUrl();
      _this.setState({
        loading: true
      }, function () {
        if (register) {
          onSignup({
            name: name,
            email: email,
            plainPassword: password,
            privacyCheck: true
          });
        } else {
          mutation.mutate({
            body: {
              email: email,
              password: password,
              _remember_me: _remember_me
            },
            params: {
              redirectUrl: redirectUrl
            }
          });
        }
      });
    });
    _defineProperty(_this, "toggleForm", function () {
      _this.setState({
        register: !_this.state.register,
        error: ''
      });
    });
    _defineProperty(_this, "togglePassword", function () {
      _this.setState({
        type: _this.state.type === 'password' ? 'text' : 'password'
      });
    });
    return _this;
  }
  _inherits(LoginForm, _Component);
  return _createClass(LoginForm, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
        signUpRequest = _this$props2.signUpRequest,
        redirectToLoggedIn = _this$props2.redirectToLoggedIn,
        mutation = _this$props2.mutation,
        match = _this$props2.match;
      var register = this.state.register;
      if (mutation.isSuccess || signUpRequest && signUpRequest.networkStatus === 'success') {
        var _mutation$data;
        if (!!((_mutation$data = mutation.data) !== null && _mutation$data !== void 0 && _mutation$data.redirectUrl)) {
          redirectToLoggedIn(mutation.data.redirectUrl);
          return;
        }
        redirectToLoggedIn("/".concat(String(match.params.projectSlug), "/closed"));
        return;
      }
      if ((mutation.isError || signUpRequest && signUpRequest.networkStatus === 'failed') && this.state.loading) {
        var _mutation$error;
        var error = register ? get(signUpRequest, 'errorBody.message') : (_mutation$error = mutation.error) === null || _mutation$error === void 0 || (_mutation$error = _mutation$error.data) === null || _mutation$error === void 0 ? void 0 : _mutation$error.message;
        if (error === 'Email-address/password combination not found') {
          error = 'Combinatie van e-mailadres en wachtwoord is niet correct.';
        }
        this.setState({
          error: error,
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        match = _this$props3.match,
        handleClick = _this$props3.handleClick;
      var _this$state = this.state,
        type = _this$state.type,
        loading = _this$state.loading,
        register = _this$state.register,
        error = _this$state.error;
      var loginForm = [{
        options: [{
          id: 'email',
          name: 'email',
          label: 'E-mailadres',
          required: true,
          title: 'E-mailadres',
          type: 'email'
        }, {
          id: 'password',
          name: 'password',
          label: 'Wachtwoord',
          required: true,
          title: 'Wachtwoord',
          type: type,
          toggle: true
        }, {
          id: '_remember_me',
          name: '_remember_me',
          label: 'Onthoud mij',
          required: false,
          title: '',
          type: 'checkbox',
          choices: [{
            key: '_remember_me',
            value: 'Onthoud mij',
            defaultChecked: true
          }],
          excludeFromSubmit: true
        }]
      }];
      var registerForm = [{
        options: [{
          id: 'name',
          name: 'name',
          label: 'Aanspreeknaam',
          required: true,
          title: 'Aanspreeknaam',
          type: 'text'
        }, {
          id: 'email',
          name: 'email',
          label: 'E-mailadres',
          required: true,
          title: 'E-mailadres',
          type: 'email'
        }, {
          id: 'email_double',
          name: 'email_double',
          doubleFor: 'email',
          label: 'Herhaal e-mailadres',
          required: true,
          title: 'Herhaal e-mailadres',
          type: 'email',
          validationMessage: 'De e-mailadressen die je hebt ingevuld, komen niet overeen'
        }, {
          id: 'password',
          name: 'password',
          label: 'Wachtwoord',
          required: true,
          title: 'Wachtwoord',
          type: type,
          toggle: true,
          help: 'Gebruik acht of meer tekens met een combinatie van letters, cijfers en symbolen'
        }, {
          id: 'privacy',
          type: 'readOnly',
          title: 'privacy-note',
          name: 'Privacy beleid',
          label: '[p]We gebruiken de gegevens die je achterlaat om onze producten en diensten steeds beter te maken en jouw gebruikerservaring zo goed mogelijk af te stemmen op jouw profiel. In ons [pagenode="0" type="link"]privacybeleid[/pagenode] lees je precies hoe we omgaan met de door jou opgegeven informatie.[/p]',
          pages: _defineProperty({}, 0, {
            env: 'open',
            projectSlug: String(match.params.projectSlug),
            menuSlug: 'sectionpage',
            pageSlug: 'privacy-statement'
          }),
          excludeFromSubmit: true
        }, {
          id: 'privacyCheck',
          name: 'privacyCheck',
          label: 'Ik ga akkoord met het privacybeleid',
          validationMessage: 'Je bent nog niet akkoord gegaan met het privacy statement',
          required: true,
          title: '',
          type: 'checkbox',
          choices: [{
            key: 'privacyCheck',
            value: 'Ik ga akkoord met het privacybeleid',
            defaultChecked: false
          }]
        }]
      }];
      return __jsx(Form, {
        loading: loading,
        "data-id": "components_LoginForm_Form"
      }, __jsx(FormTitle, {
        "data-id": "components_LoginForm_FormTitle"
      }, register ? 'Maak een account aan' : 'Log in met je account'), __jsx(FormIntro, {
        "data-id": "components_LoginForm_FormIntro"
      }, register ? 'Heb je al een account?' : 'Heb je nog geen account?', __jsx("span", {
        "data-e2e-login-form-toggle": true,
        onClick: this.toggleForm,
        "data-id": "components_LoginForm_span"
      }, register ? 'Log dan in' : 'Maak een account aan')), error && __jsx(FormError, {
        "data-id": "components_LoginForm_FormError"
      }, error), __jsx(FormFields, {
        "data-id": "components_LoginForm_FormFields"
      }, __jsx(FormGenerator, {
        fields: register ? registerForm : loginForm,
        submitLabel: register ? 'Aanmelden' : 'Inloggen',
        loadingLabel: "aanvraag wordt verwerkt",
        submitFn: this.handleSubmit,
        loading: loading,
        togglePassword: this.togglePassword,
        "data-id": "components_LoginForm_FormGenerator"
      })), __jsx(FormFooter, {
        "data-id": "components_LoginForm_FormFooter"
      }, !register && __jsx(Span, {
        onClick: function onClick(evt) {
          return handleClick(evt, {
            type: 'password',
            componentProps: {
              changePassword: false
            }
          });
        },
        "data-id": "components_LoginForm_Span"
      }, "Wachtwoord vergeten?")));
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(withMutationRequest(LoginForm, 'postLogin')));
var Form = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  opacity: ", ";\n  transition: opacity 0.25s ease-in-out;\n"])), function (props) {
  return props.loading ? '0.5' : '1';
});
var FormFields = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n\n  .formfield_privacyCheck {\n    margin-top: -40rem;\n    margin-bottom: 50rem;\n  }\n  .formfield_privacy {\n    > div > p {\n      color: ", ";\n      margin-top: 10rem;\n    }\n  }\n"])), colorPalette.textGrey);
var FormError = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 20rem;\n  justify-content: center;\n  border: solid 1px #eee;\n  border-radius: 5rem;\n  background: ", ";\n  font-family: ", ";\n  color: red;\n"])), colorPalette.lightGrey, fonts.primary);
var Span = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", " font-weight: normal;\n  font-style: italic;\n  color: ", ";\n  margin-bottom: 40rem;\n  cursor: pointer;\n  width: fit-content;\n\n  ", ";\n"])), textStyles.subTitle, colorPalette.blue, toBreakpoint.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    margin-bottom: 32rem;\n  "]))));
var FormFooter = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  margin-top: 30rem;\n  margin-bottom: 40rem;\n  color: ", ";\n\n  ", ";\n"])), textStyles.caption, colorPalette.textGrey, toBreakpoint.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: 12rem;\n    margin-top: 28rem;\n    margin-bottom: 32rem;\n  "]))));
var FormTitle = styled.h2(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-top: 60rem;\n\n  ", "\n"])), textStyles.sectionTitle, colorPalette.headerGrey, toBreakpoint.md(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    margin-top: 30rem;\n  "]))));
var FormIntro = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  ", " font-weight: normal;\n  font-style: italic;\n  color: ", ";\n  margin-bottom: 25rem;\n  margin-top: -15rem;\n\n  > span {\n    color: ", ";\n    cursor: pointer;\n    margin-left: 5rem;\n    border-bottom: 1rem solid transparent;\n    transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n\n    &:hover {\n      color: ", ";\n      border-bottom: 1rem solid ", ";\n    }\n  }\n"])), textStyles.subTitle, colorPalette.textGrey, colorPalette.blue, colorPalette.darkBlue, colorPalette.darkBlue);